import React from 'react'
import "./Why_we_exist.css"
import Common_title from '../../common/common-title/Common_title'
import Why_we_exist_card from './why-we-exist-card/Why_we_exist_card'

function Why_we_exist() {
    return (
        <>
            <section className='Why_we_exist margin_section'>
                <div className="container">
                    <Common_title headingText="Why We  " spanText=" Exist" />
                    <div className="text_holder">
                        <p>Managing rent and bills manually is outdated missed deadlines, last-minute cash, scattered records. We’re here to change that.</p>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-4 col-sm-6 mb-3">
                            <Why_we_exist_card imgSrc="/assets/images/about/why-we-exist/bell.png" text="Smart Reminders keep you Informed & your Payments on time" />
                        </div>

                        <div className="col-md-4 col-sm-6 mb-3">
                            <Why_we_exist_card imgSrc="/assets/images/about/why-we-exist/Secure.png" text="Secure digital Payments that are Quick and Trackable" />
                        </div>

                        <div className="col-md-4 col-sm-6 mb-3">
                            <Why_we_exist_card imgSrc="/assets/images/about/why-we-exist/clock.png" text="One place for Rent, Electricity bills, and History" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Why_we_exist